export default __webpack_public_path__ + "static/media/calendar-scheduled.babe5078.svg";